import React, { useContext } from 'react';

import { AppLocale } from 'constant';
import { LanguageContext } from 'context/languageContext';

import { MostPlayed } from 'interfaces';

import {
  Wrapper,
  List,
  ListItem,
  ListLink,
  Bar,
  ElementName
} from './BarChart.styles';
import { useIntl } from 'react-intl';

export interface BarChartProps {
  list?: MostPlayed[];
  className?: string;
  color?: 'primary' | 'secondary';
}

const BarChart = ({ list, color = 'primary', className = '' }: BarChartProps) => {
  const intl = useIntl();
  const { locale } = useContext(LanguageContext);

  const highestNumber = list.map((item) => item.number).sort((a, b) => a - b).reverse()[0];

  const getPercentage = (value: number) => value * 100 / highestNumber;

  const Item = (element: MostPlayed) => (
    <React.Fragment>
      <Bar
        color={color}
        width={getPercentage(element?.number)}
      >
        <span>{element?.number}</span>
      </Bar>
      <ElementName>
        {
          locale === AppLocale.EN
            ? element.details?.englishName || element.details?.name || intl.formatMessage({ id: `setList.song.${element?.id}` })
            : element.details?.name || intl.formatMessage({ id: `setList.song.${element?.id}` })
        }
      </ElementName>
    </React.Fragment>
  )

  return (
    <Wrapper className={className}>
      <List>
        {
          list.map((element: MostPlayed) => (
            <ListItem key={element?.id}>
              {
                element?.details ? (
                  <ListLink to={`/albums${element?.albumId ? '/' + element?.albumId : ''}/${element?.id}`}>
                    {Item(element)}
                  </ListLink>
                ) : Item(element)
              }
            </ListItem>
          ))
        }
      </List>
    </Wrapper>
  );
};

export default BarChart;
